import axios from "axios";
import { getAuthorizationToken } from "../config/user";
const REACT_APP_API_URL = process.env.REACT_APP_API_URL;

function newInterUser(data) {
  return axios({
    method: "post",
    url: `${REACT_APP_API_URL}/create-team-user`,
    data: data,
    headers: getAuthorizationToken(),
  });
}

function getTeamUser(limit, page, searchKey, isOnlyActiveUser) {
  let url = `${REACT_APP_API_URL}/get-team-user?role=team&limit=${limit}&page=${page}&searchKey=${searchKey || ""}`;

  if (isOnlyActiveUser) {
    url += `&isOnlyActiveUser=${isOnlyActiveUser}`;
  }

  return axios({
    method: "get",
    url,
    headers: getAuthorizationToken(),
  });
}

function getCcDoctorTeamUsers({ limit = 10, page = 1, searchKey = "" } = {}) {
  const sk = String(searchKey ?? "").trim();
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/get-team-user`,
    params: {
      role: "hospitalUser",
      roleName: JSON.stringify(["ccDoctor", "CCSrDoctor"]),
      limit,
      page,
      searchKey: sk,
      isOnlyActiveUser: 1,
    },
    headers: getAuthorizationToken(),
  });
}
function getDutTeamUsers({ limit = 10, page = 1, searchKey = "" } = {}) {
  const sk = String(searchKey ?? "").trim();

  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/get-team-user`,
    params: {
      role: "hospitalUser",
      roleName: JSON.stringify(["CCCoordinator"]),
      limit,
      page,
      searchKey: sk,
      isOnlyActiveUser: 1,
    },
    headers: getAuthorizationToken(),
  });
}
function getUserResponsibilityList(limit, page) {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/user-responsibilities?limit=${limit}&page=${page}`,
    headers: getAuthorizationToken(),
  });
}
function mapUserResponsibilities(data) {
  return axios({
    method: "post",
    url: `${REACT_APP_API_URL}/map-user-responsibility`,
    data: data,
    headers: getAuthorizationToken(),
  });
}
function manageUserRole(data) {
  return axios({
    method: "put",
    url: `${REACT_APP_API_URL}/manage-user-role`,
    data: data,
    headers: getAuthorizationToken(),
  });
}
export function updateCCStageTime(ids) {
  return axios({
    method: "put",
    url: `${REACT_APP_API_URL}/update-cc-stage-time`,
    data: {
      ids: ids.ids,
      status: ids.status,
    },
    headers: getAuthorizationToken(),
  });
}
function getUserAssignedStages() {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/assigned-stages`,
    headers: getAuthorizationToken(),
  });
}
export const InterUserMangementServices = {
  newInterUser,
  getTeamUser,
  getCcDoctorTeamUsers,
  getUserResponsibilityList,
  mapUserResponsibilities,
  manageUserRole,
  getUserAssignedStages,
  updateCCStageTime,
  getDutTeamUsers,
};
